import './views/index'
import './views/show'
import './views/event_session'

import './views/patials/banner'
